import React from "react";

// ✅ Flat default structure for display and export
export const defaultWaterData = [
  {
    section: "Water withdrawal by source (in kiloliters)",
    parameter: "(i) Surface water",
    key: "surface",
    current: "",
    previous: "",
  },
  {
    section: "Water withdrawal by source (in kiloliters)",
    parameter: "(ii) Ground water",
    key: "ground",
    current: "",
    previous: "",
  },
  {
    section: "Water withdrawal by source (in kiloliters)",
    parameter: "(iii) Thirdparty water",
    key: "thirdparty",
    current: "",
    previous: "",
  },
  {
    section: "Water withdrawal by source (in kiloliters)",
    parameter: "(iv) Seawater / desalinated water",
    key: "seawater",
    current: "",
    previous: "",
  },
  {
    section: "Water withdrawal by source (in kiloliters)",
    parameter: "(v) Others",
    key: "others",
    current: "",
    previous: "",
  },
  {
    section: "Water withdrawal by source (in kiloliters)",
    parameter:
      "Total volume of water withdrawal (in kilolitres) (i + ii + iii + iv + v)",
    key: "totalWithdrawal",
    current: "",
    previous: "",
  },
  {
    section: "Water withdrawal by source (in kiloliters)",
    parameter: "Total volume of water consumption (in kilolitres)",
    key: "totalConsumption",
    current: "",
    previous: "",
  },
  {
    section: "Water withdrawal by source (in kiloliters)",
    parameter:
      "Water intensity per rupee of turnover (Total water consumption / Revenue from operations)",
    key: "intensityTurnover",
    current: "",
    previous: "",
  },
  {
    section: "Water withdrawal by source (in kiloliters)",
    parameter:
      "Water intensity per rupee of turnover adjusted for Purchasing Power Parity (PPP) (Total water consumption / Revenue from operations adjusted for PPP)",
    key: "intensityPPP",
    current: "",
    previous: "",
  },
  {
    section: "Water withdrawal by source (in kiloliters)",
    parameter: "Water intensity in terms of physical output",
    key: "intensityOutput",
    current: "",
    previous: "",
  },
  {
    section: "Water withdrawal by source (in kiloliters)",
    parameter:
      "Water intensity (optional) – the relevant metric may be selected by the entity",
    key: "intensityOptional",
    current: "",
    previous: "",
  },
];

const WaterWithdrawalAndConsumptionTable = ({ waterData, setWaterData }) => {
  const data = waterData?.length ? waterData : defaultWaterData;

  const handleChange = (index, field, value) => {
    const updated = [...data];
    updated[index][field] = value;
    setWaterData(updated);
  };

  const groupedData = data.reduce((acc, row, index) => {
    if (!acc[row.section]) acc[row.section] = [];
    acc[row.section].push({ ...row, index });
    return acc;
  }, {});

  return (
    <div
      style={{
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ backgroundColor: "#d3c9ce", fontWeight: "bold" }}>
            <th style={cellHeaderNarrow}>Parameter</th>
            <th style={cellHeader}>
              FY _____
              <br />
              Current Financial Year
            </th>
            <th style={cellHeader}>
              FY _____
              <br />
              Previous Financial Year
            </th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(groupedData).map(([section, rows], i) => (
            <React.Fragment key={i}>
              {section && (
                <tr>
                  <td colSpan={3} style={sectionStyle}>
                    {section}
                  </td>
                </tr>
              )}
              {rows.map((row) => (
                <tr key={row.key}>
                  <td style={labelCell}>{row.parameter}</td>
                  <td style={inputCell}>
                    <input
                      type="text"
                      placeholder="Current FY"
                      value={row.current || ""}
                      onChange={(e) =>
                        handleChange(row.index, "current", e.target.value)
                      }
                      style={inputStyle}
                    />
                  </td>
                  <td style={inputCell}>
                    <input
                      type="text"
                      placeholder="Previous FY"
                      value={row.previous || ""}
                      onChange={(e) =>
                        handleChange(row.index, "previous", e.target.value)
                      }
                      style={inputStyle}
                    />
                  </td>
                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Styles
const cellHeader = {
  border: "1px solid #000",
  padding: "15px",
  textAlign: "center",
  backgroundColor: "#d3c9ce",
  height: "70px",
};

const cellHeaderNarrow = {
  ...cellHeader,
  width: "30%",
};

const sectionStyle = {
  backgroundColor: "#d3c9ce",
  fontWeight: "bold",
  padding: "15px",
  border: "1px solid #000",
  textAlign: "center",
};

const labelCell = {
  border: "1px solid #000",
  padding: "10px",
  backgroundColor: "#d3c9ce",
  fontWeight: "bold",
  textAlign: "left",
  verticalAlign: "top",
  height: "80px",
  lineHeight: "1.4",
};

const inputCell = {
  border: "1px solid #000",
  padding: "10px",
  backgroundColor: "#fff",
  verticalAlign: "middle",
  textAlign: "center",
  minHeight: "80px",
};

const inputStyle = {
  width: "80%",
  padding: "30px",
  fontSize: "14px",
  border: "1px solid grey",
  borderRadius: "4px",
  outline: "none",
};

export default WaterWithdrawalAndConsumptionTable;
